import React from 'react'
import AllTechnologies from '../components/TechnologyPage/AllTechnologies'
import react from '../assets/images/react.svg'
import next from '../assets/images/next.svg'
import vite from '../assets/images/vite.svg'
import redux from '../assets/images/redux.svg'
import node from '../assets/images/node.svg'
import express from '../assets/images/express.svg'
import django from '../assets/images/django.svg'
import QTPy from '../assets/images/qtpy.svg'
import mongoDB from '../assets/images/mongoDB.svg'
import postgreSQL from '../assets/images/postgreSQL.svg'
import pocketBase from '../assets/images/pocketBase.svg'
import reactNative from '../assets/images/reactNative.svg'
import flutter from '../assets/images/flutter.svg'
import kotlin from '../assets/images/kotlin.svg'
import aws from '../assets/images/aws.svg'
import docker from '../assets/images/docker.svg'
import microsoftAzure from '../assets/images/microsoft.svg'
import jenkins from '../assets/images/jenkins.svg'
import openAI from '../assets/images/openAi.svg'
import langchain from '../assets/images/langChain.svg'
import huggingFace from '../assets/images/huggingFace.svg'
import playwrite from '../assets/images/playwrite.svg'
import microsoftTeams from '../assets/images/microsoftTeams.svg'
import projectManagement from '../assets/images/projectManagementSystem.svg'

const Technologies = [
    { id: 1, title: "Frontend Development", description: "We build responsive, interactive interfaces with fast load times and rich user experiences.", card: [{ image: react, title: "React.js" }, { image: next, title: "Next.js" }, { image: vite, title: "Vite" }, { image: redux, title: "Axios, Redux"}] },
    { id: 2, title: "Backend Development", description: "Our backend systems are designed for performance, extensibility, and maintainability.", card: [{ image: node, title: "Node.js with Knex" }, { image: django, title: "Django" }, { image: express, title: "Express.js" }, { image: QTPy, title: "QTPy" },] },
    { id: 3, title: "Database Systems", description: "We use a range of relational and NoSQL databases tailored to your data structure and scale.", card: [{ image: mongoDB, title: "MongoDB" }, { image: postgreSQL, title: "PostgreSQL" }, { image: pocketBase, title: "Pocketbase" },] },
    { id: 4, title: "Mobile Application Development", description: "We create native and cross-platform mobile apps focused on performance and user engagement.", card: [{ image: reactNative, title: "React Native" }, { image: kotlin, title: "Kotlin" }, { image: flutter, title: "Flutter" },] },
    { id: 5, title: "Cloud Infrastructure & DevOps", description: "We deploy and manage cloud-native applications with high availability and automation.", card: [{ image: aws, title: "AWS" }, { image: microsoftAzure, title: "Microsoft Azure" }, { image: docker, title: "Docker" }, { image: jenkins, title: "Jenkins" },] },
    { id: 6, title: "AI & Automation", description: "We're also equipped to integrate emerging AI technologies into client projects.", card: [{ image: openAI, title: "OpenAI" }, { image: huggingFace, title: "Hugging Face" }, { image: langchain, title: "LangChain" }, { image: playwrite, title: "Playwright" },] },
    { id: 7, title: "Communication & Project Management", description: "We maintain full transparency and smooth collaboration throughout the project lifecycle.", card: [{ image: microsoftTeams, title: "Microsoft Teams " }, { image: projectManagement, title: "In-house Project Management System" },] },
    
]

const Technology = () => {
    return (
        <div className='w-full flex items-center justify-center pt-[80px] pb-[120px]'>
            <div className='w-[90%] flex flex-col lg:gap-[94px] md:gap-[60px] xs:gap-[40px]'>

                {/* ----------------------------------------------------------------- Provided Our Services Header With Background Image and Gradient layer --------------------------------------------------------------------------------- */}

                <div className='relative w-full flex items-center justify-center bg-technologyBg bg-cover bg-center bg-no-repeat lg:rounded-[110px] sm:rounded-[67px] xs:rounded-[50px] 1400:py-[121px] lg:py-[80px] md:py-[60px] sm:py-[50px] xs:py-[30px]'>
                    {/* <div className="absolute bg-inner inset-0 bg-gradient-to-r from-[#1FA2FF] from-[0%] via-25% to-[#A6FFCB] to-[70%] opacity-20 lg:rounded-[110px] sm:rounded-[67px] xs:rounded-[50px]"></div> */}
                    <div className='lg:w-[calc(100%-220px)] md:w-[calc(100%-100px)] sm:w-[calc(100%-60px)] xs:w-[calc(100%-20px)] flex flex-col gap-[10px] text-center font-faustina  text-[#EEEEEE]'>
                        <p className='font-bold lg:text-[50px] md:text-[40px] xs:text-[32px]'>Technology Stack</p>
                        <p className='font-medium md:text-[24px] xs:text-[18px]'>Param Group of Companies builds secure, scalable digital solutions using
                            a full-stack tech approach from UI to AI.</p>
                    </div>
                </div>

                {/* ----------------------------------------------------------------- Provided Our Services Header With Background Image and Gradient layer --------------------------------------------------------------------------------- */}

                {/* ----------------------------------------------------------------- Page Contente -------------------------------------------------------------------------------------------------------------------------------------------- */}

                <div className='flex flex-col lg:gap-[111px] md:gap-[60px] xs:gap-[40px]'>
                    
                        <p className='font-poppins font-regular lg:text-[24px] xs:text-[clamp(18px,2.4vw,24px)] text-justify text-white lg:leading-[45px] md:leading-[40px] xs:leading-[30px]'>At Param Group of Companies, we use a powerful and versatile technology stack to build secure, scalable, and future-ready digital solutions. Our tools and platforms span across all layers of development — from UI design to DevOps, from mobile apps to AI automation — ensuring excellence at every level.</p>
                    {/* -------------------------------------------------------------- All Technology Container ------------------------------------------------------------------------------------------------------------------------------*/}

                    <div className='flex flex-col gap-[60px] w-full'>
                        {Technologies?.map((technology, i) => (
                            <AllTechnologies
                                title = {technology.title}
                                desc={technology.description}
                                cards = {technology.card}
                            />
                        ))}
                    </div>
                    {/* -------------------------------------------------------------- All Technology Container ------------------------------------------------------------------------------------------------------------------------------*/}

                </div>
                {/* ----------------------------------------------------------------- Page Contente -------------------------------------------------------------------------------------------------------------------------------------------- */}

            </div>
        </div>
    )
}

export default Technology


// import BGImage from '../../assets/images/jpeg/techbg.jpg'
// import PrimaryButton from '../../components/commonComponents/PrimaryButton'
// import AWS from '../../assets/images/svg/aws_logo.svg'
// import DJANGO from '../../assets/images/svg/django_logo.svg'
// import DOCKER from '../../assets/images/svg/docker_logo.svg'
// import EXPRESS from '../../assets/images/svg/express_logo.svg'
// import FLUTER from '../../assets/images/svg/flutter_logo.svg'
// import HF from '../../assets/images/svg/hf_logo.svg'
// import INHOUSE from '../../assets/images/svg/inhouse_logo.svg'
// import Jenkins from '../../assets/images/svg/jenkins_logo.svg'
// import KOTLIN from '../../assets/images/svg/kotlin_logo.svg'
// import langchain from '../../assets/images/svg/langchain-_logo.svg'
// import MicrosoftAzure from '../../assets/images/svg/microsoft_azure_logo.svg'
// import MTEAMS from '../../assets/images/svg/microsoft-teams_logo.svg'
// import MONGO from '../../assets/images/svg/mongo_logo.svg'
// import NEXT from '../../assets/images/svg/next_logo.svg'
// import NODE from '../../assets/images/svg/node_logo.svg'
// import AI from '../../assets/images/svg/openai_logo.svg'
// import PLAYWRITE from '../../assets/images/svg/playwrite_logo.svg'
// import POCKETBASE from '../../assets/images/svg/pocketbase_logo.svg'
// import POSTGRESQL from '../../assets/images/svg/postgresql_logo.svg'
// import QT from '../../assets/images/svg/Qt_logo.svg'
// import REACT from '../../assets/images/svg/react_log.svg'
// import REACTNATIVE from '../../assets/images/svg/react-native_logo.svg'
// import REDUX from '../../assets/images/svg/redux_logo.svg'
// import VITE from '../../assets/images/svg/vite_log.svg'


// import React from 'react'
// import AllTechnologies from '../components/TechnologyPage/AllTechnologies'
// import react from '../assets/images/react.svg'
// import next from '../assets/images/next.svg'
// import vite from '../assets/images/vite.svg'
// import redux from '../assets/images/redux.svg'
// import node from '../assets/images/node.svg'
// import express from '../assets/images/express.svg'
// import django from '../assets/images/django.svg'
// import QTPy from '../assets/images/qtpy.svg'
// import mongoDB from '../assets/images/mongoDB.svg'
// import postgreSQL from '../assets/images/postgreSQL.svg'
// import pocketBase from '../assets/images/pocketBase.svg'
// import reactNative from '../assets/images/reactNative.svg'
// import flutter from '../assets/images/flutter.svg'
// import kotlin from '../assets/images/kotlin.svg'
// import aws from '../assets/images/aws.svg'
// import docker from '../assets/images/docker.svg'
// import microsoftAzure from '../assets/images/microsoft.svg'
// import jenkins from '../assets/images/jenkins.svg'
// import openAI from '../assets/images/openAi.svg'
// import langchain from '../assets/images/langChain.svg'
// import huggingFace from '../assets/images/huggingFace.svg'
// import playwrite from '../assets/images/playwrite.svg'
// import microsoftTeams from '../assets/images/microsoftTeams.svg'
// import projectManagement from '../assets/images/projectManagementSystem.svg'

// const sections = [
//     {
//         title: "Frontend Development",
//         description:
//             "We build responsive, interactive interfaces with fast load times and rich user experiences.",
//         items: ["React.js", "Next.js", "Vite", "Axios, Redux"],
//         itemslogo: [react, next, vite, redux]
//     },
//     {
//         title: "Backend Development",
//         description:
//             "Our backend systems are designed for performance, extensibility, and maintainability.",
//         items: ["Node.js with Knex", "Django", "Express.js", "QTpy"],
//         itemslogo: [node, django, express, QTPy]
//     },
//     {
//         title: "Database Systems",
//         description:
//             "We use a range of relational and NoSQL databases tailored to your data structure and scale.",
//         items: ["MongoDB", "PostgreSQL", "Pocketbase"],
//         itemslogo: [mongoDB, postgreSQL, pocketBase]
//     },
//     {
//         title: "Mobile Application Development",
//         description:
//             "We create native and cross-platform mobile apps focused on performance and user engagement.",
//         items: ["React Native", "Kotlin", "Flutter"],
//         itemslogo: [reactNative, kotlin, flutter]
//     },
//     {
//         title: "Cloud Infrastructure & DevOps",
//         description:
//             "We deploy and manage cloud-native applications with high availability and automation.",
//         items: ["AWS", "Microsoft Azure", "Docker", "Jenkins"],
//         itemslogo: [aws, microsoftAzure, docker, jenkins]
//     },
//     {
//         title: "AI & Automation",
//         description:
//             "We’re also equipped to integrate emerging AI technologies into client projects.",
//         items: ["OpenAI", "Hugging Face", "LangChain", "Playwright"],
//         itemslogo: [openAI, huggingFace, langchain, playwrite]
//     },
//     {
//         title: "Communication & Project Management",
//         description:
//             "We maintain full transparency and smooth collaboration throughout the project lifecycle.",
//         items: ["Microsoft Teams", "In-house Project Management System"],
//         itemslogo: [microsoftTeams, projectManagement]
//     },
// ];

// const Technology = () => {
//     return (
//         <>
//             <div  className='bg-cover bg-center 1024:h-[602px] 425:h-[490px] h-[300px] w-full flex justify-center items-center relative overflow-hidden'>
//                 <div className="absolute inset-0 bg-black/50"></div>
//                 <div className="absolute 1024:-top-[47px] 1024:-left-[400px] 425:-top-[80px] 425:-left-[600px] top-[100px] -left-[700px]  rounded-[50%] bg-dark-slate-blue blur-[300px] size-[800px]"></div>
//                 <div className="absolute 1024:-top-[47px] 1024:-right-[400px] 425:top-[80px] 425:-right-[600px] top-[100px] -right-[700px] rounded-[50%] bg-dark-slate-blue blur-[300px] size-[800px]"></div>

//                 <div className='z-50 flex flex-col 425:gap-12 gap-5'>
//                     <div className='flex flex-col justify-center items-center 1024:gap-10 425:gap-12 gap-5'>
//                         <p className='font-sen font-semibold text-white text-[clamp(24px,4.5vw,64px)]'>Technology Stack</p>
//                         <p className='font-sen font-medium text-white text-[clamp(18px,3.5vw,32px)] 1024:w-[65%] 425:w-[80%] w-[95%] text-center'>
//                             Param Group of Companies builds secure, scalable digital solutions using
//                             a full-stack tech approach from UI to AI.
//                         </p>
//                     </div>
//                     {/* <div className='w-full flex justify-center'>
//                         <PrimaryButton
//                             title="Get In Touch"
//                             className="bg-white text-dark-slate-blue"
//                         />
//                     </div> */}
//                 </div>
//             </div>

//             <div className='w-full flex justify-center'>
//                 <div className=' 1024:w-[calc(100%-200px)] 425:w-[calc(100%-64px)] w-[calc(100%-32px)]' >
//                     <div className='flex w-full flex-col 1024:gap-20 425:gap-15 gap-12 1024:pt-20 425:pt-12 pt-8 440:pb-[120px] pb-[80px] '>
//                         <p className='font-normal text-[clamp(16px,2.2vw,24px)] text-[#676767] font-sen'>
//                             At Param Group of Companies, we use a powerful and versatile technology stack to build secure, scalable, and future-ready digital solutions. Our tools and platforms span across all layers of development — from UI design to DevOps, from mobile apps to AI automation — ensuring excellence at every level.
//                         </p>

//                         <div className='flex flex-col 440:gap-[60px] gap-[40px] w-full items-center'>
//                             {sections.map((section, index) => (
//                                 <div key={index} className='flex flex-col gap-10 w-full'>
//                                     <div className='flex flex-col gap-4 text-center'>
//                                         <p className='font-sen text-[clamp(24px,5.7vw,60px)] font-semibold text-dark-slate-blue'>{section.title}</p>
//                                         <p className='font-sen text-[clamp(16px,2.3vw,24px)] text-[#676767]'>{section.description}</p>
//                                     </div>
//                                     <div className="flex w-full justify-center items-center flex-wrap gap-5">
//                                         {section.items.map((item, idx) => (
//                                             <div
//                                                 key={idx}
//                                                 className="px-[7%] py-4 text-[#676767] border border-[#E0E0E0] rounded-[15px] drop-shadow-[5px_10px_20px_rgba(124,124,124,0.08)] bg-white font-sen flex flex-col items-center justify-center gap-2 "
//                                             >
//                                                 {section.itemslogo[idx] && (
//                                                     <img
//                                                         src={section.itemslogo[idx]}
//                                                         alt={item}
//                                                         className="425:w-[100px] 425:h-[50px] w-[80px] h-[40px] object-contain"
//                                                     />
//                                                 )}
//                                                 <p className="text-center text-[clamp(20px,3vw,32px)] font-sen">{item}</p>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }
// export default Technology
